import { post, put, remove } from "./api";

export const saveDraftEmail = async (workspaceId: string, formData: any): Promise<any> => {
  if (formData.id) {
    const response = await put({
      path: `/workspaces/${workspaceId}/emails/drafts/${formData.id}`,
      data: formData,
    });
    return response.data;
  }
  const response = await post({
    path: `/workspaces/${workspaceId}/emails/drafts`,
    data: formData,
  });
  return response.data;
};

export const deleteDraftEmail = async (workspaceId: string, id: string): Promise<any> => {
  const response = await remove({ path: `/workspaces/${workspaceId}/emails/drafts/${id}` });
  return response.data;
};

export const sendDraftEmail = async (workspaceId: string, id: string): Promise<any> => {
  const response = await post({
    path: `/workspaces/${workspaceId}/emails/drafts/${id}/send`,
  });
  return response.data;
};

export const scheduledDraftEmail = async (
  workspaceId: string,
  id: string,
  formData: any
): Promise<any> => {
  const response = await post({
    path: `/workspaces/${workspaceId}/emails/drafts/${id}/schedule`,
    data: formData,
  });
  return response.data;
};

export const saveScheduledEmail = async (workspaceId: string, formData: any): Promise<any> => {
  if (formData.id) {
    const response = await put({
      path: `/workspaces/${workspaceId}/emails/scheduled/${formData.id}`,
      data: formData,
    });
    return response.data;
  }
  const response = await post({
    path: `/workspaces/${workspaceId}/emails/scheduled`,
    data: formData,
  });
  return response.data;
};

export const cancelScheduledEmail = async (workspaceId: string, id: string): Promise<any> => {
  const response = await post({
    path: `/workspaces/${workspaceId}/emails/scheduled/${id}/cancel`,
  });
  return response.data;
};

export const teamOutboundRecipientsHistory = async (
  workspaceId: string,
  data: any
): Promise<any> => {
  const response = await post({
    path: `/workspaces/${workspaceId}/emails/team-outbound-recipients`,
    data,
  });
  return response.data;
};

export const createTrackingPixel = async (data: any): Promise<any> => {
  const response = await post({
    path: `/email/tracking/pixel`,
    data,
  });
  return response.data;
};

export const updateTrackingPixel = async (pixelId: string, data: any): Promise<any> => {
  const response = await put({
    path: `/email/tracking/pixel/${pixelId}`,
    data,
  });
  return response.data;
};

export const sentActivitiesTrackingPixel = async (data: any): Promise<any> => {
  const response = await post({
    path: `/email/tracking/sent-activities`,
    data,
  });
  return response.data;
};
